import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BaseConfig } from "src/app/services/base-config.service";
import { EasyNotificationService } from "src/app/services/easy-notification.service";
import { WebApiClient } from "src/app/services/web-api-client.service";
import { WebApiService } from "src/app/services/web-api.service";
import { PageData2 } from "src/app/shared/models/page-data";
import { ParameterProfile } from "src/app/system/parameter-profile/models/parameter-profile";
import { ExportDataDto, exportItemTypeDto, exportItemTypes, exportSystemQuery, SystemSettingExportImportService } from "./system-setting-export-import.service";
import { FormHelper } from "src/app/services/formhelper";
import { PilotProjectQuery } from "src/app/services/api-service/hist/pilot-project-api";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MainLayoutService } from "../../services/main-layout.service";
import { FileService } from "src/app/services/api-service/file/file.service";
import { UserCache } from "src/app/services/user-cache";
import { DateHelper } from "src/app/shared/helpers/date-helper";
import { UserConfirmService } from "src/app/services/user-confirm.service";

@Component({
  selector: 'app-system-setting-export-import',
  templateUrl: './system-setting-export-import.component.html',
})
export class SystemSettingExportImportComponent implements OnInit {

  settingTypeValue: string = '';

  @Input() set settingType(value: string) {
    if (this.settingTypeValue != value) {
      this.settingTypeValue = value;
      this.pageReset();
    }
  };
  @Output() close = new EventEmitter();
  api: WebApiService;
  exportItemType = exportItemTypes;
  selectExportItemType: string[] = [];

  toggleClick: string;

  importData: ExportDataDto;

  gridView: PageData2<any> = new PageData2<any>();
  pageSize: number = BaseConfig.getConfig().ui.pageSize || 0;
  pageSkipNo = 0;

  constructor(
    private notification: EasyNotificationService,
    private webApiClient: WebApiClient,
    private apiService: SystemSettingExportImportService,
    private mainLayout: MainLayoutService,
    private fileService: FileService,
    private userConfirm: UserConfirmService,
  ) {
    this.api = this.webApiClient.createHisService('');
  }

  ngOnInit() {
    this.refreshList()
  }

  pageReset() {
    this.toggleClick = '';
    this.exportItemType.forEach(x => x.checked = false);
    this.importData = undefined;
    this.gridView = undefined;
  }

  pageChange(page: number) {
    this.pageSkipNo = page;
    this.refreshList();
  }

  // 更新清單
  async refreshList() {
    try {
      const query: exportSystemQuery = {
        pageSize: this.pageSize,
        pageSkipNo: this.pageSkipNo
      };
      const item = this.exportItemType.find(x => x.value == this.toggleClick)
      if (!item) return;
      if (this.settingTypeValue == 'export') {
        this.gridView = await this.apiService.GetAll(query, item);
      } else {
        this.gridView = await this.getImportData(query, item);
      }

      item.total = this.gridView.total
    } catch (error) {
      this.notification.showGetDataFailed()
    }
  }

  onTypeChecked(event: MatCheckboxChange, value: string) {
    this.selectExportItemType = event.checked
      ? [...this.selectExportItemType, value]
      : this.selectExportItemType.filter(x => x !== value);
  }
  async onBtnQueryClick() {
    const first = this.exportItemType.find(x => x.checked);
    this.toggleClick = first?.value ?? '';
    await this.refreshList()
  }

  async onCheckboxChange(item: exportItemTypeDto) {
    if (item.checked) {
      this.toggleClick = item?.value ?? '';
      await this.refreshList();
    }
    const allFalse = !this.exportItemType.some(x => x.checked);
    if (allFalse) { this.toggleClick = ''; }
  }

  async onBtnToggleClick(value: string) {
    this.pageSkipNo = 0;
    await this.refreshList()
  }

  get hasChecked(): boolean {
    return this.exportItemType.some(x => x.checked);
  }

  async import() {
    try {
      const text = await this.fileService.upload('json');
      this.importData = JSON.parse(text);
      const validKeys = exportItemTypes.map(x => x.value);
      const invalidKeys = Object.keys(this.importData.data)
        .filter(key => !validKeys.includes(key));
      if (invalidKeys.length) {
        this.userConfirm.showAlert('不合法資料類型:', `${invalidKeys.join(', ')}`);
        this.importData = undefined;
        return;
      }
      const keys = Object.keys(this.importData?.data ?? {});

      this.exportItemType.forEach(item => {
        item.checked = keys.includes(item.value);
        item.total = (this.importData.data[item.value] as any[])?.length ?? 0;
      });

      this.toggleClick = keys[0];
      await this.refreshList();
    } catch (e) {
      this.notification.showWarning('讀取失敗')
    }
  }

  async export() {
    const allFalse = !this.exportItemType.some(x => x.checked);
    if (allFalse) {
      this.notification.showWarning('請選擇要匯出的資料表');
      return;
    }
    try {
      this.mainLayout.showLoader();
      const exportDate: any = {
        customerCode: "匯出資料",
        exportTime: new Date().toISOString(),
        data: {}
      }
      for (const item of this.exportItemType.filter(x => x.checked)) {
        const query: exportSystemQuery = {};
        const data = await this.apiService.GetAll(query, item, 'export');
        if (Array.isArray(data)) {
          exportDate.data[item.value] = data
        } else {
          exportDate.data[item.value] = data.data
        }

      }
      const fileName =
        UserCache.getLoginUser().Clinic.Id + '_匯出資料_' +
        DateHelper.formatFullDateTime(new Date()) +
        '.json';
      this.fileService.downloadAs(JSON.stringify(exportDate), fileName);
      this.mainLayout.hideLoader();

    } catch (error) {
      console.error(error);
      this.notification.showWarning('匯出失敗');
    }

  }

  /** 將ImportData的類別顯示於List */
  async getImportData(query: exportSystemQuery, type: exportItemTypeDto): Promise<PageData2<any>> {
    const data = this.importData.data[type.value];
    if (!data) return;
    const dataItem = new PageData2();
    dataItem.total = data.length;
    dataItem.totalPages = Math.ceil(data.length / query.pageSize);
    dataItem.data = data.slice(query.pageSkipNo, query.pageSkipNo + query.pageSize);
    return dataItem;
  }

  async sandImport() {
    if (!this.importData) {
      this.notification.showWarning('沒有匯入資料!');
      return;
    }

    const errorMessage: string[] = [];
    this.mainLayout.showLoader();
    try {
      for (const type of this.exportItemType) {
        try {
          const data = this.importData.data[type.value];
          if (data) {
            await this.apiService.PostAll(data, type);
          }
        } catch (error: any) {
          console.error(error);
          errorMessage.push(`${type.text} 匯出失敗!\n${error?.message?.message as string}`);
          this.notification.showWarning(`${type.text} 匯出失敗!`);
        }
      }
      if (errorMessage.length > 0) {
        this.userConfirm.showAlert('匯入失敗', Array.from(new Set(errorMessage)).join('\n'));
        return;
      }
      this.userConfirm.showAlert('匯入完成', '匯入資料已完成\n請清除快取後再重新讀取資料。');
    } finally {
      this.mainLayout.hideLoader();
    }
  }
}
